<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15b4aUl/tc-custom/9780061853036.jpg?1731208371905" alt="This image is the cover for the book Nanny"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nanny
      </h1>
      <p class="bookDescription body article font2">
        <b>When a smalltown girl takes a nanny job in London, she must learn to navigate family dysfunction and romantic temptation in this new adult novel.</b><br/><br/>Twenty-three-year-old Jo Green knows that if she has to spend one more night in ultra-provincial Niblet-Upon-Avon she’ll go completely bonkers! So she answers an ad in the paper, bids her devoted boyfriend Shaun adieu, and heads off to the big city. With a new job that offers excitement, a cool car, and her own suite, how can she go wrong?<br/><br/>Then she meets the Fitzgeralds—Dick and Vanessa and their unruly brood of rugrats who have suddenly been entrusted into Jo’s care. There’s eight-year-old “psycho-babe” Cassandra; the bloodthirsty six-year-old Zak; and timid little Tallulah.<br/><br/>Then things get <i>really</i> complicated with the arrival of Josh, Dick’s handsome older son from his first marriage. Now forced to share her room with Josh, Jo is caught between a long-distance beau who’s still in the picture and a sexy possibility sleeping just a foot away!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Melissa Nathan
      </h2>
      
      <p class="authorDescription body article"><P>Melissa Nathan was born and raised in Hertfordshire and now lives in North London with her husband. A journalist for ten years, she writes novels full time and is the acclaimed author of <I>The Nanny</I> and <I>Pride, Prejudice and Jasmin Field</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3986b5f6